const ns = (str) => 'MANAGE_TOOL_' + str;
export const SET_JOB_TYPES = ns('SET_JOB_TYPES');
export const SET_QUERY = ns('SET_QUERY');
export const LOADING_ENTRIES = ns('LOADING_ENTRIES')
export const SET_ENTRIES = ns('SET_ENTRIES');
export const SET_JOB_TYPE = ns('SET_JOB_TYPE');
export const SET_JOBS_QUEUED_PENDING = ns('SET_JOBS_QUEUED');
export const SET_JOBS_QUEUED = ns('SET_JOBS_QUEUED');
export const RESET = ns('RESET');
export const TOGGLE_ITEM = ns('TOGGLE_ITEM');
export const SET_ALL_ITEMS_SELECTION = ns('SET_ALL_ITEMS_SELECTION')
export const SET_ITEMS_SELECTED = ns('SET_ITEMS_SELECTED')
export const SET_ENTRIES_PAGE = ns('SET_ENTRIES_PAGE');
export const CLEAR_QUEUED_STATUS = ns('CLEAR_QUEUED_STATUS');
